/** Minimal loading placeholder for workflow lists (receptors / peptides / dockings). */
export const WORKFLOW_LIST_LOADING_HTML = '<div class="workflow-list-loading" aria-busy="true" aria-live="polite">Loading…</div>';
/** True when the list is still showing only the loading placeholder (no items yet). */
export function isWorkflowListLoading(container) {
    if (!container)
        return false;
    return Boolean(container.querySelector('.workflow-list-loading'));
}
/** Remove the loading placeholder so list items never sit under/above it. */
export function clearWorkflowListLoading(container) {
    if (!container)
        return;
    container.querySelectorAll('.workflow-list-loading').forEach((el) => el.remove());
}
/**
 * Before appending a real list item: drop Loading… (and empty-state copy).
 * Loading must only occupy the list when there are no items yet.
 */
export function prepareWorkflowListForItems(container) {
    if (!container)
        return;
    clearWorkflowListLoading(container);
    container.querySelectorAll('.no-dockings, .no-items, .screening-no-items').forEach((el) => el.remove());
}
export function setWorkflowListLoading(elementId, visible = true) {
    const el = document.getElementById(elementId);
    if (!el)
        return;
    // Replace content entirely — never stack Loading on top of existing items.
    el.innerHTML = WORKFLOW_LIST_LOADING_HTML;
    if (visible) {
        el.style.display = 'block';
    }
}
export function showWorkflowPanelLoading() {
    setWorkflowListLoading('receptor-list-container', true);
    setWorkflowListLoading('peptide-list-container', true);
    const docking = document.getElementById('docking-list-container');
    if (docking) {
        docking.innerHTML = WORKFLOW_LIST_LOADING_HTML;
    }
    const screening = document.getElementById('screening-list-container');
    if (screening) {
        screening.innerHTML = WORKFLOW_LIST_LOADING_HTML;
    }
}
